import Axios from "axios";

export default function handleReset(c_id){
   // console.log(counsellingYear);
    let response = Axios.get(process.env.REACT_APP_GATEWAY_URL, {
        params: {
            a: 'handleReset',  
            c_id      
          
        }
    });
    return response;
}